var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "hospital-members__modal-content",
      attrs: { id: "organization-admin-link-screen" }
    },
    [
      _vm.isResponseMessageVisible
        ? _c(
            "div",
            { staticClass: "organization-admin-association-response-message" },
            [_c("label", [_vm._v(_vm._s(_vm.getResponseMessage))])]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("table", { staticClass: "organization-admin-association-table" }, [
        _c("tr", [
          _vm._m(0),
          _vm._v(" "),
          _c("td", [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.role,
                    expression: "role"
                  }
                ],
                attrs: {
                  id: "organization-admin-association-table__select-role"
                },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.role = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.onRoleSelected
                  ]
                }
              },
              [
                _c("option", { attrs: { value: "members" } }, [
                  _vm._v("Member")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "administrators" } }, [
                  _vm._v("Administrator")
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("td", [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.userType,
                    expression: "userType"
                  }
                ],
                attrs: {
                  id: "organization-admin-association-table__select-user-type"
                },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.userType = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.onUserTypeSelected
                  ]
                }
              },
              [
                _c("option", { attrs: { value: "existing" } }, [
                  _vm._v("Select ...")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "new" } }, [
                  _vm._v("a new user")
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("td")
        ])
      ]),
      _vm._v(" "),
      _vm.userType === "existing"
        ? _c(
            "button",
            {
              staticClass: "btn btn-default",
              attrs: {
                type: "button",
                id: "organization-admin-association__add-button",
                disabled: !_vm.isUserReadyToLink
              },
              on: { click: _vm.associateUserWitHospital }
            },
            [
              _c("span", { staticClass: "glyphicon glyphicon-plus" }),
              _vm._v(" Add\n  ")
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isAddFormVisible ? _c("organization-admin-add-form") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("label", [_vm._v("Give")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("label", [_vm._v("access to")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09495ad5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09495ad5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrganizationAdminLinkScreen/OrganizationAdminLinkScreen.vue
// module id = null
// module chunks = 